import Vue from "vue";
import VueTypedJs from "vue-typed-js";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueTelInput from "vue-tel-input";
import VueModalTor from "vue-modaltor";
import VueFacebook from "vue-facebook";
import VueCarousel from "vue-carousel";

// eslint-disable-next-line
// import styles from './assets/fonts/';
import firebase from "./firebase.js";

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(VueTelInput);

Vue.use(VueModalTor);
Vue.use(VueFacebook);
Vue.use(VueCarousel);

Vue.use(VueTypedJs);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  firebase,
  render: (h) => h(App),
}).$mount("#app");
